import styled from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';
import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';

export const Page = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 15px 30px 40px;

  @media (max-width: ${breakpoints.laptop}) {
    padding: 80px 15px 40px;
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin: 0 auto;
  max-width: 600px;
  width: 100%;
`;

export const EmptyState = styled(Text.P2)`
  color: ${colours.neutral[500]};
  padding: 30px 0;
  text-align: center;
`;

export const RevisionStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`;
